import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Centered red spinner overlay that briefly appears whenever the user
 * navigates from one route to another. Auto-dismisses after a short delay
 * so the user gets visual feedback that the transition is happening.
 */
const RouteLoader = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 450);
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none"
      data-testid="route-loader"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bg-white/40 backdrop-blur-[1.5px] absolute inset-0" />
      <div className="relative">
        <div className="w-16 h-16 rounded-full border-4 border-red-200 border-t-red-600 animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 rounded-full bg-red-600" />
        </div>
      </div>
    </div>
  );
};

export default RouteLoader;
